// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3-V6j","image":"Header_image__sw_7e","name":"Header_name__2r2Rx","info":"Header_info__1r9Bu","infoRow":"Header_infoRow__1uN3k"};